    document.onkeydown = checkKey;

    function checkKey (e) {
        e = e || window.event;

        if(e.keyCode == 37) { //LEFT
            var prev = document.getElementById("prev").href
            window.location = prev;
        } else if(e.keyCode == 39) { // RIGHT
            var next = document.getElementById("next").href
            window.location = next;
        }
    }